import { render } from "./OrgExcecutiveList.vue?vue&type=template&id=276ab0e8&scoped=true"
import script from "./OrgExcecutiveList.vue?vue&type=script&lang=js"
export * from "./OrgExcecutiveList.vue?vue&type=script&lang=js"

import "./OrgExcecutiveList.vue?vue&type=style&index=0&id=276ab0e8&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276ab0e8"]])

export default __exports__